<template>
  <BGModal :shown="dialogShown"
           :title="$t('admin_acc_item.edit_title') + (item ? (` : ${item.name}`) : '')"
           fixed-tabs>
    <template #content>
      <v-container class="edit-item-content pa-0" fluid v-if="item">
        <v-tabs fixed-tabs
                v-model="tabIndex">
          <v-tab>{{ $t('register.basic_info') }}</v-tab>
          <v-tab-item>
            <v-container class="overflow-y-scroll" fluid>
              <v-form ref="itemForm">
                <v-text-field readonly
                              :label="$t('admin_acc_item.location')"
                              v-model="item.region.location.name"></v-text-field>
                <v-text-field readonly
                              :label="$t('admin_acc_item.region')"
                              v-model="item.region.name"></v-text-field>
                <v-text-field outlined
                              :label="$t('admin_acc_item.name_en')"
                              v-model="item.name_en"
                              :rules="requiredRules"></v-text-field>
                <v-text-field outlined
                              :label="$t('admin_acc_item.name_zh')"
                              v-model="item.name_zh"
                              :rules="requiredRules"></v-text-field>
                <v-text-field readonly
                              :label="$t('admin_acc_item.item_type')"
                              v-model="item.type.name"></v-text-field>
              </v-form>
            </v-container>
          </v-tab-item>

          <v-tab>{{ $t('admin_acc_booking.title') }}</v-tab>
          <v-tab-item>
            <AdminBookingList full-height
                              :item-id="itemId"
                              @edit="onBookingEdit"
                              v-if="tabIndex === 1"></AdminBookingList>

            <EditBookingModal :shown="editBookingModalShown"
                              :booking-id="editingBookingId"
                              @cancel="editBookingModalShown = false"
                              @finish="onEditBookingModalFinish"></EditBookingModal>
            <!--            <RegionList full-height-->
            <!--                        :item-id="itemId"-->
            <!--                        @edit="onRegionEdit"-->
            <!--                        :refresh-trigger.sync="regionRefreshTrigger"-->
            <!--                        v-if="tabIndex === 1"></RegionList>-->

            <!--            <EditRegionModal :region-id="editingRegionId"-->
            <!--                             :shown="editRegionModalShown"-->
            <!--                             @cancel="onEditRegionModalFinish"></EditRegionModal>-->
          </v-tab-item>

        </v-tabs>
      </v-container>
    </template>
    <template #footer>
      <v-row no-gutters>
        <v-btn @click="cancel"
               class="mr-3"
               depressed
               large>
          {{ $t('cancel') }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary"
               depressed
               large
               @click="$refs.itemForm.validate() && saveItem()"
               v-if="tabIndex === 0">
          {{ $t('save') }}
          <v-icon right>fas fa-check</v-icon>
        </v-btn>
      </v-row>
    </template>
  </BGModal>
</template>
<script>
import BGModal from "@/components/BGModal";
import {ref, watch} from "@vue/composition-api";
import AdminBookingList from "@/components/acc_booking/booking/AdminBookingList";
import EditBookingModal from "@/components/acc_booking/booking/EditBookingModal";

export default {
  name: 'EditItemModal',
  components: {EditBookingModal, AdminBookingList, BGModal},
  props: {
    itemId: String,
    shown: Boolean,
  },
  setup(props, {root, emit}) {
    const dialogShown = ref(props.shown);
    const cancel = function () {
      emit('cancel');
    };

    const tabIndex = ref(0);

    // Init
    watch(() => props.shown, async (newValue, oldValue) => {
      if (newValue !== oldValue) {
        dialogShown.value = newValue;

        if (newValue) {
          getItem()
        }
      }

      tabIndex.value = 0;
    });

    //
    const item = ref(null);
    const getItem = function () {
      root.$callAPI('aafb/admin/item/', {item_id: props.itemId}, function (response) {
        item.value = response.body.item;
      });
    }

    //
    const requiredRules = ref([
      value => !!value || root.$t('register.required_fields'),
    ]);
    const saveItem = function () {
      root.$callAPI('aafb/admin/item/edit/', {
        ...item.value,
        item_id: props.itemId,
      }, () => {
        root.$showAlertMessage(root.$t('admin_acc_item.save_success_msg'));
        getItem()
      })
    }

    //
    const bookingRefreshTrigger = ref(false);
    const editingBookingId = ref(null);
    const editBookingModalShown = ref(false);
    const onBookingEdit = function (item) {
      editingBookingId.value = item.id;
      editBookingModalShown.value = true;
    };
    const onEditBookingModalFinish = function () {
      bookingRefreshTrigger.value = true;
      editingBookingId.value = null;
      editBookingModalShown.value = false;
    }

    return {
      dialogShown,
      cancel,

      tabIndex,

      item,
      requiredRules,
      saveItem,

      bookingRefreshTrigger,
      editingBookingId,
      editBookingModalShown,
      onBookingEdit,
      onEditBookingModalFinish,
    }
  }
}
</script>

<style lang="less">
.edit-item-content {
  display: flex;
  height: 100%;
}
</style>
